import { graphql } from "gatsby"
import useTranslations from "hooks/useTranslations"
import SEO from "components/seo"
import LogoCloudAnimated from "components/organisms/LogoCloudAnimated"
import Hero from "components/organisms/pro/Hero"
import Info1 from "components/organisms/pro/Info1"
import Coaches from "components/organisms/pro/Coaches"
import Solutions3 from "components/organisms/pro/Solutions3"
import Problems from "components/variants/ProblemsProCourses"
import Contact from "components/organisms/somebuddy/Contact"

export default function Courses({ pageContext: { currentPage } }) {
  const { schoolPageTitle, ourCustomers } = useTranslations()
  return (
    <div>
      <SEO title={schoolPageTitle} />
      <Hero />
      <Coaches />
      <Info1 />
      <Problems theme="green" />
      <Solutions3 />
      <LogoCloudAnimated
        center
        currentPage={currentPage}
        title={ourCustomers}
      />
      <Contact />
    </div>
  )
}

export const pageQuery = graphql`
  query ($locale: String!, $currentPage: String!) {
    allPrismicTestimonial(
      limit: 2
      filter: {
        lang: { eq: $locale }
        data: { show_on_pages: { elemMatch: { page: { eq: $currentPage } } } }
      }
    ) {
      nodes {
        id
        data {
          fact_large {
            text
          }
          fact_small {
            text
          }
          logo {
            url
            alt
          }
          title {
            text
          }
        }
        uid
      }
    }
  }
`
